import * as tslib_1 from "tslib";
import { OnInit, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RecaptchaComponent } from 'ng-recaptcha';
import { Router } from '@angular/router';
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@ngx-translate/core";
import * as i3 from "@angular/router";
var DemoFormPanelComponent = /** @class */ (function () {
    function DemoFormPanelComponent(http, translateService, router) {
        this.http = http;
        this.translateService = translateService;
        this.router = router;
        this.alive$ = new Subject();
        this.formText = {
            name: this.translateService.instant("demoPanel.InputField.Name"),
            email: this.translateService.instant("demoPanel.InputField.Email"),
            phone: this.translateService.instant("demoPanel.InputField.Phone"),
            company: this.translateService.instant("demoPanel.InputField.Company"),
            submit: this.translateService.instant("demoPanel.SubmitButton.GetDemo")
        };
        this.errMsg = null;
        this.succMsg = null;
        this.captchaResponse = null;
        this.requestSuccess = false;
        this.submitButton = this.translateService.instant("demoPanel.SubmitButton.GetDemo");
    }
    DemoFormPanelComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.demoGroup = new FormGroup({
                    name: new FormControl("", Validators.required),
                    email: new FormControl("", Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')])),
                    phone: new FormControl("", Validators.required),
                    company: new FormControl("", Validators.required),
                    privacyPolicy: new FormControl(false, Validators.requiredTrue)
                });
                return [2 /*return*/];
            });
        });
    };
    DemoFormPanelComponent.prototype.ngAfterViewInit = function () {
        if (this.data && this.data.capitalizeTitle && this.data.capitalizeTitle.value && this.titleEl && this.titleEl.nativeElement) {
            this.titleEl.nativeElement.style.textTransform = 'uppercase';
        }
        applyRteSettings(this.data, this.descriptionEl);
        applyTitleSettings(this.data, this.titleEl);
    };
    DemoFormPanelComponent.prototype.reCaptchaValidated = function (response) {
        this.captchaResponse = response;
    };
    DemoFormPanelComponent.prototype.sendRequest = function (event) {
        var _this = this;
        event.preventDefault();
        this.errMsg = "";
        if (!this.demoGroup.invalid && this.captchaResponse) {
            var data = tslib_1.__assign({}, this.demoGroup.value);
            data.mailType = this.data.mailType.value;
            data.reCaptchaToken = this.captchaResponse;
            this.http.post('ubaseline/api/demoFormPanel/sendRequest', data).subscribe(function (data) {
                if (data.reCaptchaFailed) {
                    _this.errMsg = _this.translateService.instant("reCaptcha.Error");
                    _this.resetCaptcha();
                    return;
                }
                _this.demoGroup.reset({
                    name: '',
                    email: '',
                    phone: '',
                    company: '',
                    privacyPolicy: false,
                });
                _this.demoGroup.markAsUntouched();
                _this.demoGroup.markAsPristine();
                _this.successOnSend();
                if (_this.data.redirectLink && _this.data.redirectLink.value && _this.data.redirectLink.value.url) {
                    _this.router.navigate([_this.data.redirectLink.value.url]);
                }
            }, function (error) { return console.log('An error has occured', error); });
        }
        else {
            if (this.demoGroup.controls.email.status === "INVALID") {
                this.errMsg = this.translateService.instant("demoPanel.ErrorMessage.Email");
            }
            else if (this.demoGroup.value.privacyPolicy) {
                this.errMsg = this.translateService.instant("demoPanel.ErrorMessage.MissingFields");
            }
            else if (!this.captchaResponse) {
                this.errMsg = this.translateService.instant("reCaptcha.CheckRecaptcha");
            }
            else {
                this.errMsg = this.translateService.instant("demoPanel.ErrorMessage.PrivacyPolicy");
            }
        }
    };
    DemoFormPanelComponent.prototype.resetCaptcha = function () {
        this.captcha.reset();
        this.captchaResponse = null;
    };
    DemoFormPanelComponent.prototype.successOnSend = function () {
        this.requestSuccess = true;
        this.succMsg = this.translateService.instant("demoPanel.SuccessMessage.OnSend");
        this.resetCaptcha();
        this.startTimer();
    };
    DemoFormPanelComponent.prototype.startTimer = function () {
        var _this = this;
        var countDown;
        var timeLeft = 5;
        var source = timer(1000, 1000);
        countDown = source.pipe(takeUntil(this.alive$)).subscribe(function (val) {
            timeLeft--;
            if (timeLeft === 0) {
                _this.requestSuccess = false;
                countDown.unsubscribe();
            }
        });
    };
    DemoFormPanelComponent.prototype.ngOnDestroy = function () {
        this.alive$.next();
        this.alive$.complete();
    };
    DemoFormPanelComponent.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DemoFormPanelComponent_Factory() { return new DemoFormPanelComponent(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.TranslateService), i0.ɵɵinject(i3.Router)); }, token: DemoFormPanelComponent, providedIn: "root" });
    return DemoFormPanelComponent;
}());
export { DemoFormPanelComponent };
